// extracted by mini-css-extract-plugin
module.exports = {"usersLabel":"EventEditor_usersLabel__2gul5","usersInput":"EventEditor_usersInput__D2Rpb","dialog":"EventEditor_dialog__L2Z5j","department":"EventEditor_department__3DINd"};